import {BACKEND} from '../../consts/backend';

const BorrarDocs = async (op, filename) => {
  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };

  await fetch(
    `${BACKEND}/deletedocs?op=${op}&filename=${filename}`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.log('error', error));
};

export default BorrarDocs;
